module.exports = __webpack_public_path__ + "static/14-8b2292b014f0a4472a11a2f05f835d2f.jpeg";